import 'core-js/es'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
// import VConsole from 'vconsole'
import ReactDOM from 'react-dom/client'
import '@/styles/index.scss'
import 'antd/dist/antd.css'
import App from './App'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
// const vConsole = new VConsole({ theme: 'dark' })

root.render(
  <App />
)